"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Titulo = exports.ContainerDeTitulos = exports.Container = void 0;
var react_1 = __importDefault(require("react"));
var rebass_1 = require("rebass");
function Container(props) {
  return react_1.default.createElement(rebass_1.Box, __assign({}, props));
}
exports.Container = Container;
function ContainerDeTitulos(props) {
  return react_1.default.createElement(rebass_1.Flex, __assign({
    sx: {
      flexWrap: "nowrap",
      overflowX: "auto"
    }
  }, props));
}
exports.ContainerDeTitulos = ContainerDeTitulos;
function Titulo(_a) {
  var sx = _a.sx,
    props = __rest(_a, ["sx"]);
  return react_1.default.createElement(rebass_1.Box, __assign({
    sx: __assign({
      whiteSpace: "nowrap",
      flexShrink: 0,
      borderBottomWidth: "4px",
      borderBottomStyle: "solid",
      borderColor: "blue4",
      color: "blue4",
      mr: 1,
      cursor: "pointer",
      "&.ativo": {
        borderColor: "blue2",
        color: "blue2"
      },
      minWidth: ["initial", "180px"],
      paddingX: 21,
      flex: 1,
      fontFamily: "heading",
      fontWeight: "bold",
      textAlign: "center"
    }, sx)
  }, props));
}
exports.Titulo = Titulo;